import {get} from 'lodash';

export default (state = {}, {candidateId, candidate}: any) => {
  return {
    ...state,
    allCandidates: {
      ...get(state, 'allCandidates', {}),
      [candidateId]: candidate,
    },
  };
};
